import React from "react";

const SearchInput = ({ onSearch, t }) => {
  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div id="kt_table_1_filter" className="dataTables_filter">
      <label>
        {t("Recherche")}:
        <input
          id="myInput"
          type="text"
          onChange={handleSearch}
          className="form-control form-control-sm"
          placeholder={t("Période")}
          aria-controls="kt_table_1"
        />
      </label>
    </div>
  );
};

export default SearchInput;
